/* ngInject */
class FooterBar {

  constructor($scope){
    'ngInject';
    this.$scope = $scope;
  }

  onLogoClick(){
    this.$scope.$emit('footerLogoClicked');
  }

  onHelpClick(){
    this.$scope.$emit('footerHelpClicked');
  }
}

module.exports = {
  template: require('./kovFooterBar.html'),
  controllerAs: 'ctrl',
  controller: FooterBar,
  bindings: {
    sVersion: '@',
    helpText: '@'
  }
};
